import {
  Heading,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
} from '@chakra-ui/react';
import CloseSharpIcon from '@gamma/ui/icons/CloseSharpIcon';
import { i18n } from '../../../../../../shared/localization';
import {
  AddNoteContent,
  AddNoteContentProps,
} from '../../../DetectionNotes/AddNote';

const {
  detection: { addNote },
} = i18n.pages.detections;

export const AddNotePopover = ({
  onClose,
  refetchMain,
}: AddNoteContentProps) => {
  return (
    <PopoverContent w="320px" data-testid="add-note-popover-content">
      <PopoverCloseButton top={1}>
        <CloseSharpIcon size="sm" />
      </PopoverCloseButton>
      <PopoverHeader>
        <Heading textStyle="body-md-bold">{addNote}</Heading>
      </PopoverHeader>
      <PopoverBody>
        <AddNoteContent onClose={onClose} refetchMain={refetchMain} />
      </PopoverBody>
    </PopoverContent>
  );
};
